<template>
    <a @click.stop="openModal" href="#">contact us</a>
</template>

<script>
import { GeneralMixin } from '@/mixins';
import ContactUs from './ContactUs';

export default {
    name: 'MailToSupport',
    mixins: [GeneralMixin],
    methods: {
        openModal() {
            this.$modal.show(ContactUs).then(() => {
                this.$modal.hide();
            });
        }
    }
};
</script>

<style scoped>
a,
a:hover {
    color: #0cdb8f !important;
    cursor: pointer !important;
    text-decoration: underline !important;
    font-weight: bold !important;
}
</style>
